import * as Yup from "yup";
import { Formik } from 'formik';

import {
    Grid,
    Dialog,
    TextField,
    Container,
    DialogTitle,
    IconButton,
    Divider,
    Card,
    CardContent,
} from "@mui/material";
import { Close } from '@mui/icons-material'
import { ActionButton } from "../../../utils/ui_utils";

function ModulesDialog({
    initialValues,
    okText,
    onSubmit,
    onClose,
    title,
    visible
}) {
    if (initialValues == undefined) {
        initialValues = { module_name: '' }
    }

    const validationSchema = Yup.object().shape({
        module_name: Yup.string().required("Required"),
    });

    const handleSubmit = async (
        values,
        { resetForm, setErrors, setStatus, setSubmitting }
    ) => {
        onSubmit(values)
    };

    return (
        <div>
            <Dialog
                PaperProps={{
                    sx: {
                        width: {
                            xs: 200,
                            sm: 300,
                        }
                    }
                }}

                open={visible} aria-labelledby="form-dialog-title">
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <Container sx={{ marginBottom: 3 }} >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={5} >
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="module_name"
                                                    label="Module Name"
                                                    value={values.module_name}
                                                    error={Boolean(touched.module_name && errors.module_name)}
                                                    fullWidth
                                                    helperText={touched.module_name && errors.module_name}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div>
    );
}

export default ModulesDialog;